import React, { useContext } from 'react';
import { useEffectOnce } from 'react-use';
import { TableLayoutContext } from '../../layout-context';
import { FooterCell } from '../footer-cell';
import { FooterRow } from '../footer-row';
import { StyledFooter } from './styled';
const renderTableFooterMap = {
    block: ({ children, ...props }) => (React.createElement(StyledFooter, { as: "div", role: "rowgroup", "aria-label": "footer", className: "footer", ...props }, children)),
    table: ({ children, ...props }) => React.createElement(StyledFooter, { ...props }, children)
};
const TableFooterLayout = ({ children, layoutType, ...props }) => {
    const renderLayout = renderTableFooterMap[layoutType];
    return renderLayout({ children, ...props });
};
export const TableFooter = ({ bottom, props, hasFooter, footerGroups, colSpan }) => {
    const layoutType = useContext(TableLayoutContext);
    useEffectOnce(() => {
        if (hasFooter && bottom) {
            console.warn('[Table] multiple sticky rows are not supported, need remove bottom or Footer');
        }
    });
    return (React.createElement(TableFooterLayout, { layoutType: layoutType },
        bottom ? (React.createElement(FooterRow, null,
            React.createElement(FooterCell, { colSpan: colSpan }, bottom))) : undefined,
        hasFooter
            ? footerGroups.map((group) => {
                const { key: rowKey, ...rowProps } = group.getFooterGroupProps();
                return (React.createElement(FooterRow, { key: rowKey, ...rowProps }, group.headers.map((column) => {
                    const { key: celKey, ...cellProps } = column.getFooterProps();
                    const isHasRender = Boolean(column.Footer);
                    return (React.createElement(FooterCell, { key: celKey, ...cellProps }, isHasRender
                        ? column.render('Footer', { additionalProps: props })
                        : undefined));
                })));
            })
            : undefined));
};
TableFooter.displayName = 'TableFooter';
